export default (dispatch) => ({
  dismiss: () => {
    dispatch({
      type: 'toast/dismiss'
    });
  }
});